/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import CompactBoardTile from 'components/compact-board-tile';
// eslint-disable-next-line no-restricted-imports
import { setBoardsMenuSelectedBoard, State } from 'modules';
import React from 'react';
import { connect, Dispatch } from 'react-redux';
// eslint-disable-next-line no-restricted-imports
import { getBoardsMenu } from 'selectors';
// eslint-disable-next-line no-restricted-imports
import {
  BoardModel,
  BoardsMenuCategoryType,
  BoardsMenuSelectedItemModel,
} from 'types/models';

interface OwnProps {
  board: BoardModel;
  showTeamName: boolean;
  type: BoardsMenuCategoryType;
  category: string;
}

interface StateProps {
  readonly selectedBoard: BoardsMenuSelectedItemModel | null;
}
interface DispatchProps {
  readonly setSelectedBoard: (
    selected: BoardsMenuSelectedItemModel | null,
  ) => void;
}

interface AllProps extends OwnProps, StateProps, DispatchProps {}

/**
 * This class serves as a wrapper around a compact board tile that allows it
 * to be rendered in a React Portal during while it is being dragged
 */
class BoardTile extends React.Component<AllProps> {
  render() {
    const { selectedBoard, board, showTeamName, type, category } = this.props;
    const selectedId = selectedBoard ? selectedBoard.id : null;
    const selectedCategory = selectedBoard ? selectedBoard.category : null;
    const focused = board.id === selectedId && category === selectedCategory;

    return (
      <CompactBoardTile
        idBoard={board.id}
        showTeamName={showTeamName}
        type={type}
        focused={focused}
      />
    );
  }
}

const mapStateToProps = (state: State): StateProps => {
  return {
    selectedBoard: getBoardsMenu(state).selectedBoard,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<State>): DispatchProps => {
  return {
    setSelectedBoard(selected: BoardsMenuSelectedItemModel | null) {
      dispatch(setBoardsMenuSelectedBoard(selected));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BoardTile);



// WEBPACK FOOTER //
// ./app/gamma/src/components/popovers/boards-menu/board-tile.tsx